// extracted by mini-css-extract-plugin
module.exports = {"page":"OrderList_page__28kdy","mainTable":"OrderList_mainTable__KKTEE","subBtnStyle":"OrderList_subBtnStyle__2ELKs","inputStyle":"OrderList_inputStyle__35zvN"};